<template>
    <div v-if="petComp">
    <div class="container" >
      <div class="modal fade" v-bind:id="petId" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <img class="pet-image" style="float:left; margin-right:5px" :src="profilePhotoPathComp"/>
              <h2 class="modal-title"> {{petComp.Name}}</h2>
              <h4 class="modal-title"> {{genderToString(petComp.Gender)}} {{petTypeToString(petComp.PetType)}}</h4>
              <h4 class="modal-title"> {{ageToString(petComp.AgeYears, petComp.AgeMonths)}}</h4>
            </div>
            <div class="modal-body row">
              <div class="photo-images" v-if="petComp.PetPhotoDtos && petComp.PetPhotoDtos.length>1">
                    <div>
                    <div class="thumb-wrap" :href="photo.Path" data-fancybox="pet-photo" v-for="photo in petComp.PetPhotoDtos">
                        <img :src="photo.Path" class="small-images" style="margin:2px;">
                    </div>
                    </div>  
              </div>
              <hr v-if="petComp.PetPhotoDtos && petComp.PetPhotoDtos.length>1">
              <div class="col-sm-12">
              <h4 style="margin-bottom:0px;"> Health Status</h4>
                <ul style="list-style-type: none; padding:5px">
                    <li v-if="petComp.RabiesVaccinated!=true"><i class="fa fa-thumbs-o-down"></i> Rabies Vaccinated</li>
                    <li v-else="petComp.RabiesVaccinated==true"><i class="fa fa-thumbs-o-up"></i> Rabies Vaccinated</li>

                    <li v-if="petComp.IsNeuteredOrSpayed!=true"><i class="fa fa-thumbs-o-down"></i> Neutered or Spayed</li>
                    <li v-else="petComp.IsNeuteredOrSpayed==true"><i class="fa fa-thumbs-o-up"></i> Neutered or Spayed</li>

                    <li v-if="petComp.TicksOrFleas!=true"><i class="fa fa-thumbs-o-down"></i> Clean from Ticks & Fleas</li>
                    <li v-else="petComp.TicksOrFleas==true"><i class="fa fa-thumbs-o-up"></i> Clean from Ticks & Fleas</li>
                </ul>
              </div>
              <div class="col-sm-12">
              <h4 style="margin-bottom:0px;"> More Information</h4>
                <ul style="list-style-type: none; padding:5px">
                    <li v-if="petComp.IsRegisteredwithColar!=true"><i class="fa fa-thumbs-o-down"></i> Registered with municipality</li>
                    <li v-if="petComp.IsRegisteredwithColar==true"><i class="fa fa-thumbs-o-up"></i> Registered with municipality</li>

                    <li v-if="petComp.MicrochipId==null"><i class="fa fa-thumbs-o-down"></i> MicrochipId</li>
                    <li v-else="petComp.MicrochipId"><i class="fa fa-thumbs-o-up"></i> MicrochipId: {{petComp.MicrochipId}}</li>
                    <li v-if="petComp.PreferredVet"><strong>Preferred Vet in case of emergency:</strong>  {{petComp.PreferredVet}}</li>
                    <li v-if="petComp.Remarks"><strong>Remarks:</strong>  {{petComp.Remarks}}</li>
                    
                </ul>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="pet-wrapper">
        <div class="media-body">
            <div class="media-left">
                <img :src="profilePhotoPathComp" alt="" class="media-object img-responsive img-rounded" style="min-width:60px; min-height:60px; border: 1px solid #c3c3c3;" height="80" width="80"></img>
            </div>
            
            <div class="media-left">
                <h4 class="media-heading main-name" style="padding-bottom:0px;margin-bottom:3px;"> <strong> {{petComp.Name}}</strong></h4>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;; margin-bottom:3px;" class="small text-muted"> </i>{{ageToString(petComp.AgeYears, petComp.AgeMonths)}}</p>
                <p style="padding-top:0px;margin-top:0px;padding-bottom:0px;margin-bottom:0px;" class="small text-muted">{{genderToString(petComp.Gender)}} {{petTypeToString(petComp.PetType)}}</p>
            </div>
            </div>
            <div class="media-right">
                 <button class="btn btn-block btn-info" @click="viewPetDetails()">View</button>
                <button class="btn btn-block  btn-info" @click="updatePetDetails()">Update</button>
                <button class="btn btn-block btn-warning" @click="deletePet()">Delete</button>
            </div>
    
     
        </div>
    </div>
</div>
</template>

<script>
const API_URL = "https://www.dupaws.com/services/"
import store from '../../../data/store.js'

export default {
    name: '' , 
    props: ['petId'],
    data() {
        return {
            petData: '',
            profilePhotoPath: ''
        }
    },
    methods:{
        updatePetDetails: function(){
            this.$router.push({path: 'updatePet/' + this.petId })
        },
        genderToString: function(gender){
            if (gender==1)
                return "Male"
            else if (gender==0)
                return "Female"
            else
                return "Unknown"
            
        },
        petTypeToString: function(petType){
            if (petType==1)
                return "Dog"
            else if (petType==2)
                return "Cat"
            else 
                return "Unknown"
        },
        ageToString: function(ageYears, ageMonths){
            if ((ageYears ===null || ageYears==0) && (ageMonths===null||ageMonths==0))
                return "Age not set"
            if (ageMonths===null || ageMonths==0)
                return ageYears + " years"
            else if (ageYears==null || ageYears==0)
                return ageMonths + " months"
            else 
                return ageYears + " years " + ageMonths + " months"
            
        },
        viewPetDetails: function(){
                 $('#' + this.petId).modal('show');
                 
        },
        deletePet: function(){
            self = this
              swal({
                        title: "Are you sure you want to delete " + self.petData.Name + "?",
                        type: "warning",
                        confirmButtonClass: 'btn-warning',
                        confirmButtonText: "Yes delete",
                        closeOnConfirm: false,
                        showCancelButton: true,
                        html: true
                        }, function(){
                              $.ajax({
                                        type: 'POST',
                                        url: API_URL + "api/deletePetData/" + self.petData.PetId,
                                        beforeSend: function(xhr) {
                                            xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
                                        },
                                        dataType: "json",
                                        crossDomain: true,
                                        contentType: "application/json; charset=utf-8",
                                        success: function(data) {
                                            store.commit('deletePet', self.petData)
                                             swal("Deleted!", self.petData.Name, "success");
                                        },
                                        error: function(data, status, error) {
                                            swal("Oops", data.responseJSON.Message, "error")
                                        }
                                })   
                        });
                        
          
        }
    },
    updated: function(){
          $("[data-fancybox]").fancybox({
             modal: false,
             selector : '[data-fancybox="pet-photo"]',
                  loop: true
          });
    },
    mounted: function(){
       self =this;
        var result = $.grep(store.getters.PetsList, function(e){ return e.PetId == self.petId; });
        if (result.length == 0) {
          // not found
        } else if (result.length == 1) {
            self.petData = result[0]    
        } 
   
    },
    computed: {
        petComp: function(){
            self = this
            if (self.petData)
                return self.petData
        },
        profilePhotoPathComp: function(){
            self=this;
            if (self.petComp)
                if(self.petComp.PetPhotoDtos){
                    if (self.petComp.PetPhotoDtos.length>0)
                        return self.petComp.PetPhotoDtos[0].Path
                    else
                        return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png"
                    } else 
                        return "https://www.dupaws.com/services/images/site/defaultPetPhoto.png"
            
        }
    }
}

</script>


<style scoped>


.modal {  
  text-align: center;
}

.modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.pet-wrapper{
    margin:5px;
    border: 1px;
    border-radius: 5px;
    border-style: solid;
    border-color: #c7c6c6;
    border-radius: 5px;
    padding:10px;
}



.photo-images {
    bottom: 5px;
    margin-bottom: initial;
    right: 5px;
    left: 5px;
    overflow:hidden;
    
}

.small-images {
    border: 1px solid #ddd;
    transition: all .1s ease-in;
    cursor: pointer;
    border-radius: 5px;
    display: inline-block ;
    max-width: 80%;
    height: auto;
}


.thumb-wrap {
    
    max-width: 20%;
    width:100px;
    min-width: 60px;
    display: inline-block ;
    padding: 2px;
}

.thumb-wrap:hover img{
    transform: scale(1.1);
    transition: all 1s ease-in;
    filter: brightness(.8);
}

.pet-image{
    height:100px;
    width:100px;
    
    border: 1px solid #c7c7c7;
    border-radius:5px;
}

</style> 


// WEBPACK FOOTER //
// PetProfileCard.vue?e2bf6fa4